module.exports = __webpack_public_path__ + "static/img/service6.933f1c1f.png";